import { render, staticRenderFns } from "./EnvelopeFuseaccess.vue?vue&type=template&id=55de1068"
import script from "./EnvelopeFuseaccess.vue?vue&type=script&lang=js"
export * from "./EnvelopeFuseaccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports